import { ChevronRight, Mail, MessageSquare, Notebook } from "lucide-react";
import { useState } from "react";
import Avatar from "../../../../../component/ui/avatar";

const notes = [
  {
    type: "Behavior",
    color: "bg-[#fff9e9]",
    border: "border-[#ddd7d7]",
    iconColor: "text-[#FF8F0D]",
    text: "Filler text is text that shares some characteristics of a real written text, but is random or otherwise generated. It may be used to display a sample of fonts",
    author: "Lale Temori",
  },
  {
    type: "Attitude",
    color: "bg-[#ecfff0]",
    border: "border-[#ddd7d7]",
    iconColor: "text-[#8BC442]",
    text: "Filler text is text that shares some characteristics of a real written text, but is random or otherwise generated. It may be used to display a sample of fonts",
    author: "Lale Temori",
  },
  {
    type: "Negative",
    color: "bg-[#fff2f5]",
    border: "border-[#ddd7d7]",
    iconColor: "text-[#FF0000]",
    text: "Filler text is text that shares some characteristics of a real written text, but is random or otherwise generated. It may be used to display a sample of fonts",
    author: "Lale Temori",
  },
];

function TabPlaceholder({ icon: Icon, title, message }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center border border-dashed border-slate-300 rounded-2xl bg-white">
      <div className="flex items-center justify-center size-14 rounded-full bg-slate-100 mb-4">
        <Icon className="size-6 text-slate-500" />
      </div>
      <h3 className="text-lg font-semibold text-slate-700">{title}</h3>
      <p className="text-sm text-slate-500 mt-1">{message}</p>
      <div className="mt-4 px-4 py-2 text-xs text-slate-400 border border-solid border-slate-200 rounded-full bg-slate-50">
        🚧 Under Development
      </div>
    </div>
  );
}

function NoteCard({ type, color, border, iconColor, text, author }) {
  return (
    <div
      className={`${color} ${border} border rounded p-[10px] flex flex-col gap-[15px]`}
    >
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-1.5">
          <span className="text-[#212121] text-[18px]">{type}</span>
        </div>
      </div>
      <p className="text-[#666666] text-[14px] leading-4">{text}</p>
      <p className="text-[#616161] text-[10px] leading-4 font-bold">
        Created By: {author}
      </p>
    </div>
  );
}

export function RightSidebar({ isOpen, onToggle }) {
  const [tabIndex, setTabIndex] = useState(0);
  return (
    <div
      className={`
        transition-all duration-300 ease-in-out shrink-0 h-full
        ${isOpen ? "w-[450px]" : "w-0 p-0 overflow-hidden"}
      `}
    >
      <div className="p-2 flex flex-col gap-4 overflow-hidden overflow-y-auto h-full">
        {/* Tab Navigation */}
        <div className="rounded-[10px] bg-white border border-[#E1E4EA] py-[8px] px-[8px] flex-shrink-0">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-[10px]">
              {[{ label: "Note" }, { label: "Email" }, { label: "SMS" }].map(
                (item, idx) => {
                  const active = idx === tabIndex; // first tab active

                  return (
                    <button
                      key={idx}
                      className={`px-[25px] py-[7px] flex items-center gap-1 text-[14px] text-[#414651] font-medium rounded-[10px] transition-all border
                    ${active
                          ? "bg-[#F6F6F6] border-[#DDD]"
                          : "bg-[#ffffff] border-[#e1e4ea]"
                        }    
                                              `}
                      onClick={() => {
                        setTabIndex(idx);
                      }}
                    >
                      <span>{item.label}</span>
                    </button>
                  );
                }
              )}
            </div>

            {/* Right side filter icon */}
            <div className="text-[#B7B8BB] text-xl cursor-pointer transition-all hover:text-gray-600 flex gap-1 items-center">
              <button
                onClick={onToggle}
                className="p-1 rounded-md bg-blue-600 text-white 
             hover:bg-blue-700 hover:shadow-md 
             active:scale-95 
             transition-all duration-200 group"
              >
                <ChevronRight
                  size={18}
                  className="transition-transform duration-200 group-hover:translate-x-1"
                />
              </button>
            </div>
          </div>
        </div>

        {tabIndex == 0 ? (
          <div className="bg-white h-full rounded-[10px] border border-[#e1e4ea] p-[10px] flex flex-col gap-[5px]">
            <TabPlaceholder
              icon={Notebook}
              title="Notes"
              message="Notes will be available soon."
            />
          </div>
        ) : tabIndex == 1 ? (
          <div className="bg-white h-full rounded-[10px] border border-[#e1e4ea] p-[10px] flex flex-col gap-[5px]">
            <TabPlaceholder
              icon={Mail}
              title="Emails"
              message="Email activity and history will be available soon."
            />
          </div>
        ) : tabIndex == 2 ? (
          <div className="bg-white h-full rounded-[10px] border border-[#e1e4ea] p-[10px] flex flex-col gap-[5px]">
            <TabPlaceholder
              icon={MessageSquare}
              title="SMS"
              message="SMS communication history is under development."
            />
          </div>
        ) : null}
      </div>
    </div>
  );
}
